import { BreadcrumbList, ListItem, WithContext } from "schema-dts";
import { Brand, Model } from "@app/store/types";
import { PROJECT_NAME } from "@shared/config/GlobalText";
import { configApi } from "@shared/lib/configApi";
import { RouterConfig } from "@shared/lib/routerConfig";
import { RouterSlugs } from "@shared/lib/routerSlugs";

export const getBreadcrumbCatalogSchema = (
    brand?: Brand | null,
    model?: Model | null
): WithContext<BreadcrumbList> => {
    const baseItems: ListItem[] = [
        {
            "@type": "ListItem",
            position: 1,
            item: {
                "@type": "Thing",
                "@id": configApi.API_PUBLIC_DOMAIN,
                name: PROJECT_NAME
            }
        },
        {
            "@type": "ListItem",
            position: 2,
            item: {
                "@type": "Thing",
                "@id": `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.CATALOG}`,
                name: "Каталог"
            }
        }
    ];

    if (brand && brand.alias) {
        baseItems.push({
            "@type": "ListItem",
            position: 3,
            item: {
                "@type": "Thing",
                "@id": `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.CATALOG}/${RouterSlugs.SLUG_ALL_CITIES}/${brand.alias}/${RouterSlugs.SLUG_FILTERS_END}`,
                name: brand.name
            }
        });
    }

    if (brand && model && model.alias) {
        baseItems.push({
            "@type": "ListItem",
            position: 4,
            item: {
                "@type": "Thing",
                "@id": `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.CATALOG}/${RouterSlugs.SLUG_ALL_CITIES}/${brand.alias}/${model.alias}/${RouterSlugs.SLUG_FILTERS_END}`,
                name: model.name
            }
        });
    }

    const schema: WithContext<BreadcrumbList> = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: baseItems
    };

    return schema;
};